<template>
  <div class="template">
    <el-table :data="templateData" :show-header='false' style="width: 100%" border highlight-current-row row-key='KeyId' :expand-row-keys='expandArr' :header-cell-class-name="must" >
      <el-table-column type="expand">
        <template slot-scope="props" v-if="props.row.ChildList._Items.length>0">
          <template-com :templateData='props.row.ChildList._Items'  v-if="props.row.ChildList._Items[0].QuestionType==='空题'" @deleteQuestion='deleteQuestion'></template-com>
          <template v-if="props.row.ChildList._Items[0].QuestionType==='判断题'">
            <deduction-template :templateData='props.row.ChildList._Items'  @deleteQuestion='deleteQuestion'></deduction-template>
          </template>
        </template>
      </el-table-column> 
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> 
      <el-table-column label="检查指标" min-width="200" prop="Title" header-align="center">
      </el-table-column> 
      <el-table-column label="计分规则名称" width="200" prop="CaculatePolicyName" header-align="center">
      </el-table-column> 
      <el-table-column label="描述" width="200" prop="Description" header-align="center">
      </el-table-column>
      <el-table-column label="得分" width="100" align="center">
        <template slot-scope="scoped">
          {{scoped.row.AnswerContent?scoped.row.AnswerContent.Grade:'-'}}
        </template>
      </el-table-column>
      <el-table-column label="计分" width="100" prop="Score" align="center" header-align="center">
      </el-table-column> 
    </el-table>
  </div>
</template>

<script>
import deductionTemplate from './deductionTemplate';
import { ExamineQuestion } from '@/service/ExamineController/ExaminePaper';
export default {
  name: 'template-com',
  components: {
    'deduction-template': deductionTemplate,
  },
  props: {
    templateData: Array,
    codeRuleType: Array,
  },
  data() {
    return {
      expandArr: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    addTemplates(row) {
      if (
        row.row.Title === '' ||
        row.row.CaculatePolicyName === '' ||
        row.row.Score === null
      ) {
        return this.$message({
          type: 'error',
          message: '请填写完整后再添加',
        });
      }
      if (
        row.row.ChildList._Items.length > 0 &&
        row.row.ChildList._Items[0].QuestionType !== '空题'
      ) {
        row.row.ChildList._Items = [];
        row.row.ChildList._Items.push(
          new ExamineQuestion({ QuestionType: '空题' })
        );
      } else {
        row.row.ChildList._Items.push(
          new ExamineQuestion({ QuestionType: '空题' })
        );
      }
    },
    // 修改
    modifyQuestion(row) {
      row.Changed = true;
    },
    // 删除
    deleteRow(idx) {
      this.$emit('deleteQuestion', this.templateData[idx].KeyId);
      this.templateData.splice(idx, 1);
    },
    deleteQuestion(val) {
      this.$emit('deleteQuestion', val);
    },
    //添加问题
    addHandle(row, type) {
      this.expandArr.push(row.row.KeyId);
      if (
        row.row.Title === '' ||
        row.row.CaculatePolicyName === '' ||
        row.row.Score === null
      ) {
        return this.$message({
          type: 'error',
          message: '请填写完整后再添加',
        });
      }
      if (
        row.row.ChildList._Items.length > 0 &&
        row.row.ChildList._Items[0].QuestionType === '空题'
      ) {
        row.row.ChildList._Items = [];
      }
      row.row.ChildList._Items.push(
        new ExamineQuestion({ QuestionType: type })
      );
    },
    must() {},
  },
};
</script>
<style lang="scss" scoped>
.template {
  .el-dropdown-link {
    color: #409eff;
    font-size: 12px;
  }
}
</style>
